import { Component } from "@angular/core";

@Component({
    selector: "thirdparty-icon",
    templateUrl: "./thirdparty-icon.component.svg",
    standalone: true,
    host: { class: "cerrix-icon" },
})
export class ThirdPartyIconComponent {}
